import { useState } from 'preact/hooks';
import { ownerOf } from './bets';
import { CAT_DISPLAY, ORIGINAL_IMG, catIcon } from './cats';
import { formatGap, formatTime } from './format';
import { HudStore } from './store';
import { TicketIcon } from './TicketIcon';

export function Standings({ store }: { store: HudStore }) {
  // Collapsed keeps only the leader's and the followed cat's rows, so more of the race shows on a small screen.
  const [collapsed, setCollapsed] = useState(false);
  const snap = store.snapshot.value;
  if (!snap) return null;
  const followed = store.followed.value;
  const ranked = [...snap.cats].sort((a, b) => a.place - b.place);
  const finishes = store.finishes.value;
  const bets = store.bets.value.filter((b) => b.status === 'active');
  /** Who backs each cat in an open bet, e.g. "JP". */
  const backers = (id: typeof ranked[number]['id']) => [...new Set(bets.map((b) => ownerOf(b, id)?.name).filter(Boolean))].slice(0, 2).join(', ');
  return (
    <section class={`panel standings${collapsed ? ' collapsed' : ''}`} aria-label="Standings">
      <header>
        <button type="button" class="collapse" aria-expanded={!collapsed} aria-controls="standings-list" title={collapsed ? 'Show all six cats' : 'Show only the leader and the cat you follow'}
          onClick={() => setCollapsed(!collapsed)}>Standings <span class="chevron" aria-hidden="true">▾</span></button>
        <span class="gap-head" title="Gap: metres behind the leader; finish time once the race is over">Gap · m / time</span>
      </header>
      <ol id="standings-list">
        {ranked.map((c) => {
          const d = CAT_DISPLAY[c.id];
          const st = HudStore.status(c, snap, finishes[c.id]);
          const leader = c.place === 1;
          const official = snap.results?.find((x) => x.id === c.id);
          const isFollowed = followed === c.id;
          const backer = backers(c.id);
          return (
            <li key={c.id} class={`row${leader ? ' leader' : ''}${isFollowed ? ' followed' : ''}`} style={{ '--cat': d.colour }}>
              <button type="button" class="row-main" onClick={() => store.follow(isFollowed ? null : c.id)}
                aria-pressed={isFollowed} aria-label={`${d.name}, place ${c.place}, ${st.text}.${backer ? ` Bet: ${backer}.` : ''} ${isFollowed ? 'Stop following' : 'Follow'}`}>
                <span class="rank">{c.place}</span>
                <span class="icon" aria-hidden="true"><img src={catIcon(c.id, c)} alt="" width={40} height={40} data-testid={`standings-icon-${c.id}`} /><span class="lane-no">{d.lane + 1}</span></span>
                <span class="who">
                  <span class="name">{d.short}</span>
                  <span class="tags">
                    {leader && <span class="tag lead"><img src={ORIGINAL_IMG.star} alt="" class="tag-img" /><span class="label"> LEADER</span></span>}
                    {isFollowed && <span class="tag follow">◎<span class="label"> FOLLOWING</span></span>}
                    {backer && <span class="tag bet" title={`In a bet: ${backer}`}><TicketIcon /><span class="label"> {backer}</span></span>}
                    <span class={`tag state${st.text === 'Running' ? ' running' : ''}`}>{c.tripping && !c.finished ? <img src={ORIGINAL_IMG.catnip} alt="" class="tag-img" /> : c.eating && !c.finished ? <img src={ORIGINAL_IMG.ham} alt="" class="tag-img ham" /> : st.icon}<span class="label"> {st.text}</span></span>
                  </span>
                </span>
                <span class="gap">{official && !official.dsq ? formatTime(official.seconds) : leader ? '' : formatGap(c.gapToLeader)}</span>
              </button>
              <button type="button" class="info" aria-label={`About ${d.name}`} onClick={() => { store.cardOpen.value = c.id; }}>i</button>
            </li>
          );
        })}
      </ol>
    </section>
  );
}
